import { useLazyQuery } from "@apollo/client";
import { FC, Fragment, useEffect, useRef, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { useRecoilValue, useSetRecoilState } from "recoil";
import ChooseCountryModal from "~/components/Modals/ChooseCountry/ChooseCountryModal";
import SkeletonByTimeout from "~/components/Skeletons/SkeletonByTimeout";
import Text from "~/components/Text";
import Colors from "~/constants/colors";
import { QUERY_SHIPPING_BY_COUNTRY } from "~/data/product/gql";
import { AvailableRegions, CountriesAtom, Country } from "~/services/countries";

const ShippingMethodSelect: FC<any> = ({ text }) => {
  const [selectedCountry, setSelectdCountry] = useState<any>({
    label: "",
  });
  const [selectedRegions, setSelectdRegions] = useState<any>({});
  const [open, setModal] = useState<any>(false);

  const [queryShippingByCountry, { data, loading }] = useLazyQuery(
    QUERY_SHIPPING_BY_COUNTRY,
    {
      nextFetchPolicy: "cache-and-network",
    }
  );

  // const {countrySelected} = contents
  const setCountries = useSetRecoilState(CountriesAtom.countries);
  const { countrySelected, countries, regionSelected } = useRecoilValue(
    CountriesAtom.countriesSelector
  );

  const init = useRef(false);
  useEffect(() => {
    // if(country.countrySelected?.value ){
    //   setCountries(countriesLoadable.contents)
    // }
    if (countrySelected?.value && !init.current) {
      setSelectdCountry(countrySelected);
      setSelectdRegions(regionSelected);

      init.current = true;
    }
  }, [countrySelected?.value]);

  const handleConfirm = async (
    countrySelected: Country,
    regionSelected: AvailableRegions
  ) => {
    await queryShippingByCountry({
      variables: {
        country_code: countrySelected.value,
      },
    });
    setSelectdCountry(countrySelected);
    setSelectdRegions(regionSelected);
    setModal(false);
    setCountries((prev) => ({
      ...prev,
      countrySelected,
      regionSelected,
    }));
  };

  return (
    <Fragment>
      <div className="flex gap-3 items-center">
        {/* <Image
          src="/svgs/vn_flag.svg"
          alt="VN Flag"
          width={27}
          height={20}
      
        /> */}
        <Text type="body-2">
          {text ?? "Deliver to"}{" "}
          <Text
            htmlTag="span"
            className="inline"
            type="label-3"
            color={Colors.PRIMARY}
            onClick={() => setModal(true)}
          >
            {!!regionSelected?.name ? regionSelected?.name + ", " : null}
            {!selectedCountry?.label ? (
              <span className="inline-flex">
                <SkeletonByTimeout>
                  <Skeleton className="w-[100px] inline-flex" />
                </SkeletonByTimeout>
              </span>
            ) : (
              selectedCountry.label
            )}
          </Text>{" "}
          <Text
            htmlTag="span"
            className="underline cursor-pointer inline"
            type="title-4"
            color={Colors.PRIMARY}
            onClick={() => setModal(true)}
          >
            Change
          </Text>
        </Text>
      </div>
      <ChooseCountryModal
        open={open}
        onCancel={() => setModal(false)}
        loading={loading}
        countries={countries}
        country={selectedCountry}
        region={selectedRegions}
        onConfirm={handleConfirm}
      />
    </Fragment>
  );
};

export default ShippingMethodSelect;
